import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomeLayout from "./layouts/HomeLayout";
import Layout from "./layouts/Layout";

import Company from "./views/Company";
import Company2 from "./views/Company2";
import Company3 from "./views/Company3";
import Works from "./views/Works";
import Works2 from "./views/Works2";
import Works3 from "./views/Works3";
import Works4 from "./views/Works4";
import Community from "./views/Community";
import Community2 from "./views/Community2";
import Community3 from "./views/Community3";
import Contact from "./views/Contact";
import Contact2 from "./views/Contact2";
import Contact3 from "./views/Contact3";

function App() {
  return (
    <Router>
      <Routes>
        {/* 홈 페이지 */}
        <Route path="/" element={<HomeLayout />} />

        {/* 회사 소개 */}
        <Route path="/company" element={<Layout />}>
          <Route index element={<Company />} />
        </Route>
        <Route path="/company2" element={<Layout />}>
          <Route index element={<Company2 />} />
        </Route>
        <Route path="/company3" element={<Layout />}>
          <Route index element={<Company3 />} />
        </Route>

        {/* 사업 소개 */}
        <Route path="/works" element={<Layout />}>
          <Route index element={<Works />} />
        </Route>
        <Route path="/works2" element={<Layout />}>
          <Route index element={<Works2 />} />
        </Route>
        <Route path="/works3" element={<Layout />}>
          <Route index element={<Works3 />} />
        </Route>
        <Route path="/works4" element={<Layout />}>
          <Route index element={<Works4 />} />
        </Route>

        {/* 커뮤니티 */}
        <Route path="/community" element={<Layout />}>
          <Route index element={<Community />} />
        </Route>
        <Route path="/community2" element={<Layout />}>
          <Route index element={<Community2 />} />
        </Route>
        <Route path="/community3" element={<Layout />}>
          <Route index element={<Community3 />} />
        </Route>

        {/* 문의 */}
        <Route path="/contact" element={<Layout />}>
          <Route index element={<Contact />} />
        </Route>
        <Route path="/contact2" element={<Layout />}>
          <Route index element={<Contact2 />} />
        </Route>
        <Route path="/contact3" element={<Layout />}>
          <Route index element={<Contact3 />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
